import { mapGetters } from 'vuex';

export default {
  name: 'BrandButton',

  props: {
    type: {
      type: String,
      default: 'simple',
      validator(val) {
        return ['simple', 'cancel', 'primary'].includes(val);
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    ...mapGetters(['brandColors']),
    __colors() { // for fix unit tests
      return this.colors || (this.brandColors || {});
    },
    buttonTypeClass() {
      return ({
        simple: 'BrandButton--simple',
        cancel: 'BrandButton--cancel',
        primary: 'BrandButton--primary',
      })[this.type];
    },
    buttonTypeStyle() {
      return ({
        simple: {
          button: {
            backgroundColor: this.__colors.main,
          },
          icon: {
            color: this.__colors.accent,
          },
        },
        cancel: {

        },
        primary: {
          button: {
            backgroundImage: `linear-gradient(to right, 
              ${this.__colors.accent}, ${this.__colors.main})`,
          },
          icon: {},
        },
      })[this.type];
    },
  },

  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/BrandButton/component.js